module.exports = __webpack_public_path__ + "static/media/send.edbee5d0.svg";